export default __webpack_public_path__ + "static/media/Vanir Avenger.8e63575f.jpg";